<template>
    <div class="layout">
        <Layout>
            <Sider hide-trigger :style="{height:($store.state.tableHight - 65) + 'px'}" class="rx-sider">
                <Side></Side>
            </Sider>
            <Layout>
                <Headers></Headers>
                <Content class="em-body" :style="{height:($store.state.tableHight - 65) + 'px'}">
                    <Row :gutter="16" >
                        <Col span="3">
                            <div class="rx-index-box">
                                <div class="box-line">
                                    <div class="order-count text-primary">
                                        {{basic.project_money ?? '0.00'}}
                                    </div>
                                </div>
                                <div class="name">项目总额</div>
                                <Icon type="ios-cafe" size="26" class="icons" />
                            </div>
                        </Col>
                        <Col span="3">
                            <div class="rx-index-box">
                                <div class="box-line">
                                    <div class="order-count text-violet">
                                        {{basic.contract_money ?? '0.00'}}
                                    </div>
                                </div>
                                <div class="name">合同总额</div>
                                <Icon type="ios-cafe" size="26" class="icons" />
                            </div>
                        </Col>
                        <Col span="3">
                            <div class="rx-index-box">
                                <div class="box-line">
                                    <div class="order-count text-success">
                                        {{basic.income_money ?? '0.00'}}
                                    </div>
                                </div>
                                <div class="name">项目回款</div>
                                <Icon type="md-contacts" size="26" class="icons" />
                            </div>
                        </Col>
                        <Col span="3">
                            <div class="rx-index-box">
                                <div class="box-line">
                                    <div class="order-count text-danger">
                                        {{basic.debt_money ?? '0.00'}}
                                    </div>
                                </div>
                                <div class="name">项目欠款</div>
                                <Icon type="md-contacts" size="26" class="icons" />
                            </div>
                        </Col>
                        <Col span="3">
                            <div class="rx-index-box">
                                <div class="box-line">
                                    <div class="order-count text-orange">
                                        {{basic.project_expend_money ?? '0.00'}}
                                    </div>
                                </div>
                                <div class="name">项目材料支出</div>
                                <Icon type="md-contacts" size="26" class="icons" />
                            </div>
                        </Col>
                        <Col span="3">
                            <div class="rx-index-box">
                                <div class="box-line">
                                    <div class="order-count text-orange">
                                        {{basic.project_expense_money ?? '0.00'}}
                                    </div>
                                </div>
                                <div class="name">项目报销支出</div>
                                <Icon type="ios-photos" size="26" class="icons" />
                            </div>
                        </Col>
                        <Col span="3">
                            <div class="rx-index-box">
                                <div class="box-line">
                                    <div class="order-count text-warning">
                                        {{basic.expense_money ?? '0.00'}}
                                    </div>
                                </div>
                                <div class="name">员工报销金额</div>
                                <Icon type="ios-rose" size="26" class="icons" />
                            </div>
                        </Col>
                        <Col span="3">
                            <div class="rx-index-box">
                                <div class="box-line">
                                    <div class="order-count text-primary">
                                        {{basic.invoice_money ?? '0.00'}}
                                    </div>
                                </div>
                                <div class="name">发票金额</div>
                                <Icon type="ios-rose" size="26" class="icons" />
                            </div>
                        </Col>
                    </Row>
                    <Row :gutter="16">
                        <Col span="18">
                            <Card :bordered="false" class="rx-index-card" dis-hover shadow>
                                <template #title>
                                    <div class="text-primary">
                                        <Icon type="md-stats" size="16"  /> 近一年项目支出报表
                                    </div>
                                </template>
                                <template #extra>
                                   <Icon type="md-calendar" /> {{basic.date}}
                                </template>
                                <div  class="width-100 charts-box">
                                    <line-echart :search="search" ref="LineEchartBox"></line-echart>
                                </div>
                            </Card>
                        </Col>
                        <Col span="6">
                            <Card :bordered="false" class="rx-index-card" dis-hover shadow>
                                <template #title>
                                    <div class="text-primary">
                                        <Icon type="md-stats" size="16"  /> 近一年项目支出分析
                                    </div>
                                </template>
                                <template #extra>
                                    <Icon type="md-calendar" /> {{basic.date}}
                                </template>
                                <div class="otype-list">
                                    <pie-echart :search="search" ref="PieEchartBox"></pie-echart>
                                </div>
                            </Card>
                        </Col>
                    </Row>
                    <Row :gutter="16">
                        <Col span="12">
                            <Card :bordered="false" class="rx-index-card" dis-hover shadow>
                                <template #title>
                                    <div class="text-primary">
                                        <Icon type="md-stats" size="16"  /> 近一年项目采购支出报表
                                    </div>
                                </template>
                                <template #extra>
                                    <Icon type="md-calendar" /> {{basic.date}}
                                </template>
                                <div  class="width-100 charts-box">
                                    <expend-bar-echart :search="search" ref="ExpendBarEchartBox"></expend-bar-echart>
                                </div>
                            </Card>
                        </Col>
                        <Col span="12">
                            <Card :bordered="false" class="rx-index-card" dis-hover shadow>
                                <template #title>
                                    <div class="text-primary">
                                        <Icon type="md-stats" size="16"  /> 近一年项目报销支出报表
                                    </div>
                                </template>
                                <template #extra>
                                    <Icon type="md-calendar" /> {{basic.date}}
                                </template>
                                <div  class="width-100 charts-box">
                                    <bar-echart :search="search" ref="BarEchartBox"></bar-echart>
                                </div>
                            </Card>
                        </Col>
                    </Row>
                    <Row :gutter="16">
                        <Col span="24">
                            <Card :bordered="false" class="rx-index-card" dis-hover shadow>
                                <template #title>
                                    <div class="text-primary">
                                        <Icon type="md-stats" size="16"  /> 近一年员工报销报表
                                    </div>
                                </template>
                                <template #extra>
                                    <Icon type="md-calendar" /> {{basic.date}}
                                </template>
                                <div  class="width-100 charts-box">
                                    <expense-line :search="search" ref="ExpenseLinetBox"></expense-line>
                                </div>
                            </Card>
                        </Col>
                    </Row>
                </Content>
            </Layout>
        </Layout>
    </div>
</template>

<script>
import '@/assets/style.css'
import Headers from "@/components/public/Headers";
import Side from "@/components/public/Side";
import LineEchart from "@/components/echarts/HomeStaticLine";
import BarEchart from "@/components/echarts/ProjectExpenseBar";
import ExpendBarEchart from "@/components/echarts/ProjectExpendBar";
import PieEchart from "@/components/echarts/ProjectExpendPie";
import ExpenseLine from "@/components/echarts/HomeExpenseLine";
import {getStaticData} from "@/apis/static";

export default {
    name: 'HomeIndex',
    components: {
        Headers, Side, LineEchart, BarEchart, PieEchart, ExpendBarEchart, ExpenseLine
    },

    data () {
        return {

            basic: [],


            theme: 'dark',
            menu:[],
            is_full_screen:false,
            top_order_type_list: [],
            search: {
                range : 1,
                type : 'all',
            },
        }
    },
    created(){
        this.getStaticData();
        // this.GetMenu();
        // this.$refs.LineEchartBox.GetLineEchart(this.search);
    },
    mounted(){
        let that = this;
        that.HeightInit();
        document.addEventListener('fullscreenchange', this.handleFullScreenChange);
    },

    methods: {
        getStaticData(){
            let that = this;
            getStaticData().then(e=>{
                that.basic = e.data;
            })
        },
        handleFullScreenChange(){
            if (!document.fullscreenElement) {
                this.is_full_screen = false;
                // 在这里执行退出全屏后的操作
            } else {
                this.is_full_screen = true;
                // 在这里执行进入全屏后的操作
            }
        },
        toggleFullScreen() {
            if (!document.fullscreenElement) {
                this.is_full_screen = true;
                document.documentElement.requestFullscreen().catch(err => {
                    alert(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
                });
            } else {
                this.is_full_screen = false;
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                }
            }
        },
        loginOut(){},
        GetMenu(){
            let that = this;
            that.menu =  JSON.parse(decodeURIComponent(this.$store.state.auth));
            let route_info = this.$route;
            let auth =  JSON.parse(decodeURIComponent(this.$store.state.auth));
            auth.forEach((item) => {
                if(item.Id == route_info.meta.id){
                    console.log(item)
                    this.$store.commit('SET_OPEN_NAMES' , item.Id);
                    this.$store.commit('SET_ACTIVE_NAMES' ,item.Id);
                    this.$store.commit('SET_PARENT_ROUTER_NAME' ,item.Title);
                }else if(item.Childrens){
                    let children = item.Childrens;
                    children.forEach((items) => {
                        if(items.Id == route_info.meta.id){
                            this.$store.commit('SET_OPEN_NAMES' , item.Id);
                            this.$store.commit('SET_ACTIVE_NAMES' ,String(item.Id)+'-'+String(items.Id));
                            this.$store.commit('SET_PARENT_ROUTER_NAME' ,item.Title);
                        }
                    })
                }
            })
        },

        GoLink(url) {
            let that = this;
            that.$router.push({
                path : url,
            });
        },
        HeightInit(){
            this.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            // 动态计算 table 的高度重新赋值
            const that = this;
            window.onresize = function () {
                that.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            }
        }
    }
}
</script>

<style lang="less" scoped>
.rx-index-box {
    width: 100%;
    position: relative;
    border: 1px solid #f6f6f6;
    background: #f6f6f6;
    border-radius: 5px;
    padding: 25px 10px;
    position: relative;
    box-shadow: 5px 5px 10px #EEE;
    cursor: pointer;
    transition: all 0.2s ease-in-out 0s;
    &:hover {
        background: #f2f2f2;
        box-shadow: 5px 5px 10px #ccc;
        transition: all 0.2s ease-in-out 0s;
    }
    .name {
        width: 100%;
        font-size: 15px;
        //font-weight: bold;
    }
    .box-line {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 15px;
        .order-count {
            font-size: 20px;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .order-count-small {
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            em {
                font-size: 16px;
                padding-left: 10px;
            }
        }
    }
    .icons {
        position: absolute;
        bottom: 10px;
        right: 10px;
        color: rgba(40,130,255,0.1);
    }
}
.rx-index-card {
    margin-top: 20px;
}
</style>
